<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="收银流水" name="cashierReport">
        <search-form-template
          :searchOptions="cashierReportSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="cashierExportExcel()"
        ></search-form-template>
        <table-template ref="cashierReport" :tableOptions="cashierReportTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="支付流水" name="payReport">
        <search-form-template
          :searchOptions="payReportSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="payExportExcel()"
        ></search-form-template>
        <table-template ref="payReport" :tableOptions="payReportTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="销售流水" name="goodsReport">
        <search-form-template
          :searchOptions="goodsReportSearchOptions"
          @clear="clearSearch"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
          @btnCommon="goodsExportExcel()"
        ></search-form-template>
        <table-template ref="goodsReport" :tableOptions="goodsReportTable"></table-template>
      </el-tab-pane>
      <el-dialog
        title="组合支付详情"
        :visible.sync="listShow"
        width="1000px"
        height="2000px"
        :close-on-click-modal="false"
      >
        <list-operation :tableOptions="cashierReportListColumns" ref="listOperation"></list-operation>
      </el-dialog>
      <el-dialog
        id="bill-show-style"
        title="小票预览"
        :visible.sync="billShow"
        :close-on-click-modal="false"
      >
        <list-bill-view
          :tableOptions="billReportListColumns"
          :columns="billReportListColumns.columns"
          :list="billReportListColumns.list"
          :title="billReportListColumns.title"
          :foot="billReportListColumns.foot"
        ></list-bill-view>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from "@/components/template/searchFormTemplate";
  import tableTemplate from "@/components/template/tableTemplate";
  import api from "@/config/api";
  import userPower from "@/mixin/userPower";
  import listOperation from '@/components/template/listOperation';
  import listBillView from "@/components/template/listBillView"

  export default {
    mixins: [userPower],
    name: "RoleManager",
    components: {
      tableTemplate,
      searchFormTemplate,
      listOperation,
      listBillView
    },
    data() {
      return {
        activeTab: "cashierReport",
        loading: false,
        listShow: false,
        billShow: false,
        treeConfig: {
          id: "menuTree",
          showCheckbox: true,
          data: [],
          nodeKey: "id",
          defaultProps: {
            children: "children",
            label: "name",
          },
          request: {
            api: api.system.rolePrivilege,
            param: {roleId: ""},
          },
        },
        // 采购明细汇总高级查询
        cashierReportSearchOptions: {
          simple: [
            {
              label: "",
              type: "input",
              prop: "orderNo",
              isFuzzy: true,
              placeholder: "请输入流水票号/会员名称",
            },
          ],
          complex: [
            {
              label: "选择日期",
              prop: "CreateDttm",
              type: "dateTimeRangeButton",
              dateType: "datetime",
              span: 24,
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              span: 8,
              isHasAll: true,
              change: this.getCashierChange,
              url: api.system.seStore,
            },

            {
              label: "导购员",
              type: "select",
              prop: "guideId",
              data: [],
              span: 8,
              // url: api.system.account,
              // param: { type: 50 },
            },
            {
              label: "收银员",
              type: "select",
              prop: "cashierId",
              data: [],
              span: 8,
              // param: { type: 40 },
              // url: api.system.account,
            },
            {
              label: "交易类型",
              type: "select",
              prop: "orderType",
              span: 8,
              data: this.$utils.getCacheStatus('soBillOrder.orderTypeV2'),
            },
            // {
            //   label: "支付方式",
            //   type: "select",
            //   prop: "payType",
            //   data: this.$utils.getCacheStatus("soBillOrderPay.payType"),
            //   change: this.payTypeChange,
            //   span: 8,
            // },
            // {
            //   label: "销售方式",
            //   prop: "orderType",
            //   type: "radio",
            //   span: 12,
            //   data: this.$utils.getCacheStatus('soBillOrder.orderType'),
            // },
            // {
            //   label: "单据类型",
            //   prop: "type",
            //   type: "radio",
            //   span: 12,
            //   data: this.$utils.getCacheStatus('soBillOrder.type'),
            // },
            // {
            //   label: "其他支付",
            //   type: "select",
            //   prop: "otherPayId",
            //   data: [],
            //   url: api.system.otherPay,
            //   span: 8,
            //   hidden: true
            // },
          ],
        },
        // 采购明细汇总高级查询
        payReportSearchOptions: {
          simple: [
            {
              label: "",
              type: "input",
              prop: "tradeNo",
              isFuzzy: true,
              placeholder: "请输入流水票号",
            },
          ],
          complex: [
            {
              label: "选择日期",
              prop: "CreateDttm",
              type: "dateTimeRangeButton",
              dateType: "datetime",
              span: 24,
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              span: 8,
              isHasAll: true,
              change: this.getPayChange,
              url: api.system.seStore,
            },
            {
              label: "收银员",
              type: "select",
              prop: "cashierId",
              data: [],
              span: 8,
            },
            {
              label: "支付方式",
              type: "select",
              prop: "payType",
              data: this.$utils.getCacheStatus("soBillOrderPay.payType"),
              change: this.getotherPay,
              span: 8,
            },
            {
              label: "其他支付",
              type: "select",
              prop: "otherPayId",
              hidden:true,
              data: []
            },
          ],
        },
        // 销售流水
        goodsReportSearchOptions: {
          simple: [
            {
              label: "",
              type: "input",
              prop: "orderNo",
              isFuzzy: true,
              placeholder: "请输入流水票号/商品名称",
            },
          ],
          complex: [
            {
              label: "选择日期",
              prop: "CreateDttm",
              type: "dateTimeRangeButton",
              dateType: "datetime",
              span: 24,
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 8,
              data: [],
              isHasAll: true,
              change: this.getGoodsChange,
              url: api.store.store,
            },
            {
              label: "供应商",
              type: "select",
              prop: "supplierId",
              data: [],
              span: 8,
            },
            {
              label: "品牌",
              type: "select",
              prop: "brandId",
              data: [],
              span: 8
            },
            {
              label: "类别",
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 8,
              change: this.typeChange,
              url: api.archives.getCategoryTree,
            },
            {
              label: "导购员",
              type: "select",
              prop: "guideId",
              data: [],
              span: 8,
              // url: api.system.account,
              // param: {type: 50},
            },
            {
              label: "收银员",
              type: "select",
              prop: "cashierId",
              data: [],
              span: 8,
              // param: {type: 40},
              // url: api.system.account,
            },
            // {
            //   label: "供应商",
            //   type: "select",
            //   prop: "supplier_id",
            //   data: [],
            //   span: 12,
            //   url: api.archives.supplier,
            // },
            {
              label: "交易类型",
              type: "select",
              prop: "orderType",
              span: 8,
              data: this.$utils.getCacheStatus('soBillOrder.orderTypeV2'),
            },
            // {
            //   label: "销售方式",
            //   prop: "orderType",
            //   type: "radio",
            //   span: 12,
            //   data: this.$utils.getCacheStatus('soBillOrder.orderType'),
            // },
            {
              label: "单据类型",
              prop: "type",
              type: "radio",
              span: 8,
              data: this.$utils.getCacheStatus('soBillOrder.type'),
            },
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: "打印",
            code: "print",
          },
          {
            label: "导出",
            code: "export",
            callback: this.exportExcel
          },
        ],
        //收银流水
        cashierReportTable: {
          showSummary: true,
          summaryColumns: ['allPrice', 'payPrice', 'discountPrice', 'malingAmount'],
          //summaryMethod:this.summaryMethod,
          indexShow: true, //是否显示索引
          indexMethod: (index) => {
            //自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: "门店名称",
              prop: "storeName",
              width: "160",
              align: "center",
            },
            {
              label: "单据类型",
              prop: "type",
              width: "100",
              align: "center",
              enumData: this.$utils.getCacheStatus("soBillOrder.type"),
            },
            {
              label: "票号",
              prop: "orderNo",
              width: "220",
              align: "center",
              showBillView: true,
              code: 'showBillView',
              callback: this.showBillView,
            },
            {
              label: "销售时间",
              prop: "createDttm",
              width: "180",
              align: "center",
            },
            {
              label: "交易类型",
              prop: "orderType",
              width: "100",
              align: "center",
              enumData: this.$utils.getCacheStatus("soBillOrder.orderType"),
            },
            {
              label: "原价金额",
              prop: "allPrice",
              width: "100",
              align: "center",
            },
            {
              label: "实付金额",
              prop: "payPrice",
              width: "100",
              align: "center",
              showDetailBox: true,
              code: 'showDetailBox',
              callback: this.showDetailBox,
            },
            {
              label: "优惠金额",
              prop: "discountPrice",
              width: "100",
              align: "center"
            },
            // {
            //   label: "支付方式",
            //   prop: "payType",
            //   width: "120",
            //   align: "center",
            //   enumData: this.$utils.getCacheStatus("soBillOrder.payType"),
            // },
            {
              label: "抹零金额",
              prop: "malingAmount",
              width: "120",
              align: "center"
            },
            {
              label: "会员姓名",
              prop: "memberName",
              width: "95",
              align: "center",
            },
            {
              label: "会员手机",
              prop: "memberPhone",
              width: "100",
              align: "center",
            },
            {
              label: "收银员",
              prop: "cashierName",
              width: "95",
              align: "center",
            },
            {
              label: "导购员",
              prop: "guideName",
              width: "95",
              align: "center",
            },
            {
              label: "退货原单号",
              prop: "refundNo",
              width: "200",
              align: "center",
            },
            // {
            //   label: "付款备注",
            //   prop: "orderPayRemarks",
            //   width: "150",
            //   align: "center",
            // },
            {
              label: "单据备注",
              prop: "billOrderRemarks",
              width: "150",
              align: "center",
            },
          ],
          param: {
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          url: api.retail.cashierReport,
        },
        //支付方式记录
        payReportTable: {
          showSummary: true,
          summaryColumns: ['payPrice'],
          indexShow: true, //是否显示索引
          indexMethod: (index) => {
            //自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: "门店名称",
              prop: "storeName",
              width: "160",
              align: "center",
            },
            {
              label: "票号",
              prop: "tradeNo",
              width: "220",
              align: "center",
            },
            {
              label: "销售时间",
              prop: "createDttm",
              width: "180",
              align: "center",
            },
            {
              label: "实付金额",
              prop: "payPrice",
              width: "100",
              align: "center",
            },
            {
              label: "支付方式",
              prop: "payTypeName",
              width: "120",
              align: "center",
            },
            {
              label: "收银员",
              prop: "cashierName",
              width: "95",
              align: "center",
            },
            // {
            //   label: "会员名称",
            //   prop: "memberName",
            //   width: "95",
            //   align: "center",
            // },
            // {
            //   label: "付款备注",
            //   prop: "remarks",
            //   width: "150",
            //   align: "center",
            // },
          ],
          param: {
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          url: api.retail.payReport,
        },
        //小票预览信息
        billReportListColumns: {
          title: {
            orderType: {
              label: '',
              prop: ''
            },
            orderNo: {
              label: '',
              prop: ''
            },
            lastModifyDttm: {
              label: '',
              prop: ''
            },
            mbMemberId: {
              label: '',
              prop: ''
            },
            cashierName: {
              label: '',
              prop: ''
            },
          },
          foot: {
            allPrice: {
              label: '',
              prop: ''
            },
            discountPrice: {
              label: '',
              prop: ''
            },
            amountReceived: {
              label: '',
              prop: ''
            },
            payType: {
              label: '',
              prop: ''
            },
          },
          list: [],
          columns: [
            {
              label: '名称',
              prop: 'goodsName',
              width: '20%',
            },
            {
              label: '原价',
              prop: 'retailPrice',
              width: '20%',
              enumData: this.$utils.getCacheStatus("soBillOrder.retailPrice")
            },
            {
              label: '单价',
              prop: 'unitPrice',
              width: '20%',
              enumData: this.$utils.getCacheStatus("soBillOrder.payType")
            },
            {
              label: '数量',
              prop: 'goodsNum',
              width: '20%',
            },
            {
              label: '合计',
              prop: 'payPrice',
              width: '20%',
            },
          ],
        },
        cashierReportListColumns: {
          disabled: false,
          indexShow: true, //是否显示索引
          summaryColumns: ['payPrice'],
          columns: [
            {label: '序号', type: 'index', width: 100, prop: 'idx'},
            {
              label: '订单号',
              prop: 'tradeNo',
              width: '100',
            },
            {
              label: '支付方式',
              prop: 'payType',
              width: '100',
              enumData: this.$utils.getCacheStatus("soBillOrder.payType")
            },
            {
              label: '支付金额',
              prop: 'payPrice',
              width: '100',
            },
            {
              label: '支付时间',
              prop: 'createDttm',
              width: '100',
            },
          ],
        },
        //商品流水
        goodsReportTable: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'artificialDiscountMoney', 'refundPrice',
            'payPrice', 'allPrice', 'memberDiscountMoney', 'activityDiscountMoney'],
          indexShow: true, //是否显示索引
          indexMethod: (index) => {
            //自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: "门店名称",
              prop: "storeName",
              width: "160",
              align: "center",
            },
            // {
            //   label: "门店编码",
            //   prop: "storeCode",
            //   width: "100",
            //   align: "center",
            // },
            {
              label: "票号",
              prop: "orderNo",
              width: "220",
              align: "center",
              showBillView: true,
              code: 'showBillView',
              callback: this.showBillView,
            },
            {
              label: "收银员",
              prop: "cashierName",
              width: "100",
              align: "center",
            },
            {
              label: "导购员",
              prop: "guideName",
              width: "100",
              align: "center",
            },
            {
              label: "销售时间",
              prop: "createDttm",
              width: "180",
              align: "center",
            },
            {
              label: "条码",
              prop: "barCode",
              width: "150",
              align: "center",
            },
            {
              label: "自编码",
              prop: "artNo",
              width: "150",
              align: "center",
            },
            {
              label: "商品名称",
              prop: "goodsName",
              width: "100",
              align: "center",
            },
            {
              label: "类别",
              prop: "goodsCategoryName",
              width: "100",
              align: "center",
            },
            {
              label: "规格",
              prop: "specs",
              width: "100",
              align: "center",
            },
            {
              label: "单位",
              prop: "unitName",
              width: "70",
              align: "center",
            },
            {
              label: "原价",
              prop: "retailPrice",
              width: "70",
              align: "center",
            },
            {
              label: "数量",
              prop: "goodsNum",
              width: "70",
              align: "center",
            },
            {
              label: "原价金额",
              prop: "allPrice",
              width: "120",
              align: "center",
            },
            {
              label: "手动折扣",
              prop: "artificialDiscountMoney",
              width: "120",
              align: "center",
            }, {
              label: "会员优惠",
              prop: "memberDiscountMoney",
              width: "120",
              align: "center",
            },
            {
              label: "活动优惠",
              prop: "activityDiscountMoney",
              width: "120",
              align: "center",
            },
            {
              label: "退款金额",
              prop: "refundPrice",
              width: "100",
              align: "center",
            },
            {
              label: "销售金额",
              prop: "payPrice",
              width: "120",
              align: "center",
            },
            {
              label: "单据备注",
              prop: "billOrderRemarks",
              width: "150",
              align: "center",
            },
          ],
          param: {
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          url: api.retail.goodsReport,
        },
        tabLabel: '收银流水',
      };
    },
    created() {
      this.title = document.title;
      this.setStore(this.cashierReportSearchOptions.complex);
      this.setStore(this.goodsReportSearchOptions.complex);
      this.getCashier();
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.code == '2') {//智能分析跳转过来
          this.activeTab = 'goodsReport'
        }
      }
    },
    methods: {
      // 合计
      summaryMethod(param) {
        //console.log(param)
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "总计";
            return;
          }
          let hasSummary =
            this.cashierReportTable.summaryColumns.filter((item) => {
              return item == column.property;
            }).length > 0;
          // const values = data.map((item) => Number(item[column.property]));
          // if (!values.every((value) => isNaN(value)) && hasSummary) {
          //   sums[index] = values.reduce((prev, curr) => {
          //     const value = Number(curr);
          //     if (!isNaN(value)) {
          //       return prev + curr;
          //     } else {
          //       return prev;
          //     }
          //   }, 0);
          // } else {
          //   sums[index] = "";
          // }
          if (hasSummary) {
            sums[index] = this.sumEntity[column.property];
          } else {
            sums[index] = "";
          }
        });
        let keys = Object.keys(sums);
        for (let i = 0; i < keys.length; i++) {
          if (typeof(sums[keys[i]]) == "number")
            sums[keys[i]] = this.$utils.returnFloat(sums[keys[i]]);
        }
        return sums;
      },
      payTypeChange(row) {
        if (row.payType === 80) {
          this.cashierReportSearchOptions.complex.filter(item => item.prop === 'otherPayId')[0].hidden = false;
        } else {
          this.cashierReportSearchOptions.complex.filter(item => item.prop === 'otherPayId')[0].hidden = true;
        }
      },
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      tabChange(val) {
        this.tabLabel = val.label
        this.$refs[this.activeTab].operationSuccess();
      },
      clearSearch() {
        //console.log(this.$refs['cashierReport']);
        this.$refs['cashierReport'].clearSearch();
        this.$refs['goodsReport'].clearSearch();
        let userInfo = this.$utils.getSysUser();
        if (!userInfo.storeId) {
          this.cashierReportSearchOptions.complex.filter(item => item.prop === 'guideId')[0].data = []
          this.cashierReportSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
          this.goodsReportSearchOptions.complex.filter(item => item.prop === 'guideId')[0].data = []
          this.goodsReportSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
          this.goodsReportSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
          this.goodsReportSearchOptions.complex.filter(item => item.prop === 'brandId')[0].data = []
        }
      },
      getCashier() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.system.staffPage + '/list', {}).then(data => {
            this.cashierReportSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
            this.goodsReportSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          });
          this.$axios.fetchPost(api.system.guide + '/list', {type: 50}).then(data => {
            this.cashierReportSearchOptions.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
            this.goodsReportSearchOptions.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
          });
          this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: userInfo.storeId}).then(data => {
            if (data.code === 200) {
              this.goodsReportSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
            }
          });
          this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: userInfo.storeId}).then(data => {
            if (data.code === 200) {
              this.goodsReportSearchOptions.complex.filter(item => item.prop === 'brandId')[0].data = data.data;
            }
          })
        }
      },
      // 收银流水 高级搜索选择门店
      getCashierChange(form) {
        form.cashierId = '';
        form.guideId = '';
        // 收银员
        this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.cashierReportSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        });
        // 导购员
        this.$axios.fetchPost(api.system.guide + '/list', {storeId: form.storeId, type: 50}).then(data => {
          if (data.code === 200) {
            this.cashierReportSearchOptions.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
          }
        })
      },
      // 销售流水 高级搜索选择门店
      getGoodsChange(form) {
        form.cashierId = '';
        form.guideId = '';
        this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.goodsReportSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        });
        this.$axios.fetchPost(api.system.guide + '/list', {storeId: form.storeId, type: 50}).then(data => {
          if (data.code === 200) {
            this.goodsReportSearchOptions.complex.filter(item => item.prop === 'guideId')[0].data = data.data;
          }
        })
        form.supplierId = '';
        form.brandId = ''
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.goodsReportSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        });
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.goodsReportSearchOptions.complex.filter(item => item.prop === 'brandId')[0].data = data.data;
          }
        })
      },
      getPayChange(form) {
        form.cashierId = '';
        form.otherPayId = '';
        // 收银员
        this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.payReportSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        });
        // 其他支付
        // this.$axios.fetchPost(api.system.sysPayMode, {storeId: form.storeId}).then(data => {
        //   if (data.code === 200) {
        //     this.payReportSearchOptions.complex.filter(item => item.prop === 'otherPayId')[0].data = data.data;
        //   }
        // });
      },
      getotherPay(form){
        console.log('110',form);
        let otherPayId =  this.payReportSearchOptions.complex.filter(item => item.prop === 'otherPayId')[0];
        // 其他支付
        if(form.payType === 80){
          this.$axios.fetchPost(api.system.sysPayMode, {storeId: form.storeId}).then(data => {
            if (data.code === 200) {
              otherPayId.data = data.data;
              otherPayId.hidden = false;
            }
          });
        } else {
          otherPayId.data = [];
          otherPayId.hidden = true;
        }
      },
      // 收银流水报表导出
      cashierExportExcel() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["cashierReport"].searchParam;
        this.$axios.PostBlob(api.retail.cashierReportExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '收银流水_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      // 销售流水报表导出
      goodsExportExcel() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["goodsReport"].searchParam;
        this.$axios.PostBlob(api.retail.goodsReportExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '销售流水_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      // 支付流水报表导出
      payExportExcel() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["payReport"].searchParam;
        this.$axios.PostBlob(api.retail.payReportExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '支付流水_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      showDetailBox(data) {
        this.listShow = true;
        this.$axios
          .fetchPost(api.retail.payDetail, {tradeNo: data.orderNo})
          .then((data) => {
            if (data.code === 200) {
              this.$nextTick(() => {
                this.$refs['listOperation'].clearTableData();
                this.$refs['listOperation'].addMoreRow(data.data, 0);
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
          });
      },
      // 小票预览
      showBillView(val) {
        let paramsId = null
        if (this.tabLabel == '销售流水') {
          paramsId = val.billId
        } else {
          paramsId = val.id
        }
        this.billShow = true
        this.$axios
          .fetchGet(api.retail.billDetail + '?id=' + paramsId, {})
          .then((res) => {
            if (res.code === 200) {
              //订单类型取值
              let soBillOrderOrderType = JSON.parse(localStorage.getItem('STATUSDATA'))['soBillOrder.orderType']
              soBillOrderOrderType.forEach(v => {
                if (v.value == res.data.orderType) {
                  res.data.orderType = v.label
                }
              })
              this.billReportListColumns.title = {
                orderType: {label: '订单类型', prop: res.data.orderType},
                orderNo: {label: '单号', prop: res.data.orderNo},
                lastModifyDttm: {label: '时间', prop: res.data.lastModifyDttm},
                mbMemberId: {label: '会员ID', prop: res.data.mbMemberId},
                cashierName: {label: '收银员', prop: res.data.cashierName}
              }
              //支付方式取值
              let soBillOrderPaytype = JSON.parse(localStorage.getItem('STATUSDATA'))['soBillOrder.payType']
              soBillOrderPaytype.forEach(v => {
                if (v.value == res.data.payType) {
                  res.data.payType = v.label
                }
              })
              this.billReportListColumns.foot = {
                allPrice: {label: '合计', prop: res.data.allPrice},
                discountPrice: {label: '优惠', prop: res.data.discountPrice},
                amountReceived: {label: '实收', prop: res.data.amountReceived},
                payType: {label: '支付方式', prop: res.data.payType},
              }
              this.billReportListColumns.list = res.data.soBillOrderGoodsMapMVOList
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
          });
      },
    },
  };
</script>

<style scoped>
  #bill-show-style .el-dialog {
    min-width: 300px !important;
  }

  .page-template {
    padding-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/page/retail/query/flow/Report.vue